import Configuracion from './Configuration';
export default Configuracion;